import { Dispatch, ReactNode, SetStateAction } from 'react';

export enum Placement {
  Top = 'top',
  TopStart = 'top-start',
  TopEnd = 'top-end',
  Right = 'right',
  RightStart = 'right-start',
  RightEnd = 'right-end',
  Bottom = 'bottom',
  BottomStart = 'bottom-start',
  BottomEnd = 'bottom-end',
  Left = 'left',
  LeftStart = 'left-start',
  LeftEnd = 'left-end',
}
export interface PopoverProps {
  anchor: string;
  children: ReactNode;
  className?: string;
  placement?: Placement;
  clickable?: boolean;
  opened: boolean;
  offset?: number;
  maxHeight?: number;
  arrow?: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  text?: string;
}
